import { useNotificationsToggle } from "../../hooks/useNotificationsToggle";
import { useCreativeJobsListener } from "../../hooks/useCreativeJobsListener";
import NotificationsButton from "./NotificationsButton";

/**
 * Notifications button component for NavBar
 * Handles toggle of the global notifications panel
 */
const GlobalNotificationsAlert = ({ sx }) => {
  useCreativeJobsListener();
  const { onToggle, hasActiveProcessing } = useNotificationsToggle();

  return (
    <NotificationsButton
      id="notifications-toggle-button"
      onClick={onToggle}
      hasActiveProcessing={hasActiveProcessing}
      disabled={false}
      sx={sx}
    />
  );
};

export default GlobalNotificationsAlert;
